import { Flex, HStack } from '@chakra-ui/react';
import { memo } from 'react';
import ListenAudio from '../HelperComponents/ListenAudio';
import HLine from './HLine';
import TagOption, { EmptyTag } from './TagOption';
import useWithOrder from './useWithOrder';

const ListenWithOrder = memo(({
  exercise,
  setSelectedAnswer,
  disabled,
  selectedAnswer,
  ...props
}) => {
  const { 
    mediaList, 
    selectedOptions, 
    onItemClick, 
    onSelectedItemClick,
    currentlyPlaying,
    onAudioPlay,
    stopAllAudio
  } = useWithOrder({
    exercise,
    setSelectedAnswer,
    selectedAnswer,
    hasAudio: true,
    disabled  // Pass disabled to hook
  });

  return (
    <Flex 
      p={[0, 0, 4]}
      direction={['column', 'column', 'row']}
      gap={[4, 4, 8]}
      width="100%"
      data-testid={props['data-testid']}
    >
      <Flex flex={[1, 1, 0.3]} justifyContent="center">
        <ListenAudio
          data={exercise}
          audioControl={{
            currentlyPlaying,
            onAudioPlay,
            stopAllAudio
          }}
          containerProps={{
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%'
          }}
        />
      </Flex>
      
      <Flex 
        flex={[1, 1, 0.7]} 
        direction="column" 
        gap={4}
        minWidth={['100%', '100%', '70%']}
      >
        <HStack 
          border="1px solid"
          borderColor="gray.200"
          minHeight={100}
          p={2}
          borderRadius="md"
          wrap="wrap"
          align="center"
          justify="center"
        >
          {selectedOptions.map((option, index) => (
            <TagOption
              key={`selected-${option.key}-${index}`}
              option={option}
              disabled={disabled}
              onClick={() => !disabled && onSelectedItemClick(option, index)}
              border="2px solid"
              borderColor="blue.500"
              _hover={!disabled ? { bg: 'blue.50' } : {}}
              transition="all 0.2s"
            />
          ))}
        </HStack>
        
        <HStack 
          wrap="wrap" 
          gap={2} 
          justify="center"
          align="center"
        >
          {mediaList.map((option, index) => (
            option ? (
              <TagOption
                key={`available-${option.key}-${index}`}
                option={option}
                disabled={disabled}
                separator={<HLine />}
                onClick={() => !disabled && onItemClick(option, index)}
                border="1px solid"
                borderColor="gray.300"
                borderRadius="md"
                bg="white"
                _hover={!disabled ? { 
                  transform: 'translateY(-2px)',
                  boxShadow: 'md'
                } : {}}
                transition="all 0.2s"
              />
            ) : (
              <EmptyTag key={`empty-${index}`} />
            )
          ))}
        </HStack>
      </Flex>
    </Flex>
  );
});

export default ListenWithOrder;